// Colors from go/brand.
const brandPurple = '#7611B6'
const brandHighlight = '#AD50FF'
const brandBlack = '#2D2E43'
const brandWhite = '#FFFFFF'
const brandPop = '#C86DD7'
const purpleGradient = `linear-gradient(135deg, ${brandPurple}, 50%, ${brandPop})`
const purpleGradientHover = `linear-gradient(135deg, ${brandPurple}, 80%, ${brandPop})`

// Gray shades from lightest to darkest.
const moonlight = '#F9F9FA'
const white = '#FFFFFF'
const gray1 = '#EBEBF1'
const gray2 = '#D5D7E4'
const gray3 = '#B5B8D0'
const gray4 = '#8083A2'
const gray5 = '#464766'
const gray6 = '#3A3B55'

const darkBackground = '#20292E'
const darkBackground2 = '#2F3940'
const darkBackground3 = '#262E34'
const darkBackground4 = '#29292B'
const darkBackground5 = '#323232'

export {
  brandPurple,
  brandHighlight,
  brandBlack,
  brandWhite,
  brandPop,
  purpleGradient,
  purpleGradientHover,
  moonlight,
  white,
  gray1,
  gray2,
  gray3,
  gray4,
  gray5,
  gray6,
  darkBackground,
  darkBackground2,
  darkBackground3,
  darkBackground4,
  darkBackground5,
}
